import {NavLink, type NavLinkProps} from '@mantine/core'
import {useMatch, useNavigate} from 'react-router-dom'

type Props = NavLinkProps & {
  to: string
}

export const CustomNavLink = ({to, ...rest}: Props) => {
  const navigate = useNavigate()
  const active = !!useMatch(to)
  return <NavLink onMouseDown={() => navigate(to)} active={active} {...rest} />
}
